<template>
  <div class="flex flex-column">
    <div class="silver f6">
      <font-awesome-icon :icon="['fa', 'user']" class="mr2"/>
      <slot name="author" />
    </div>

    <div class="lh-copy mv2 f6">
      <slot name="comment" />
    </div>

    <div class="silver f6">
      <slot name="datetime" />
    </div>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
</style>
